module.exports = __webpack_public_path__ + "img/CM-BS-25-Acura-Modern.1772ecd8.jpg";